import React, { useState } from 'react'
import { FileIcon, Anchor } from '../../lib/components'
import { DOCUMENTS } from '../../lib/utils/message'
import { truncateString } from '../../lib/utils/helpers'
import { OpportunityDetails } from '../../lib/types'
import { OpportunityExpandableSection } from './cms-components/opportunity-expandable-section'

type OpportunityDetailDocumentsProps = {
  documents?: OpportunityDetails['documents']
  defaultExpanded?: boolean
}

const OpportunityDetailDocuments = ({
  documents,
  defaultExpanded = false,
}: OpportunityDetailDocumentsProps) => {
  const validDocuments = documents?.filter((document) => Boolean(document?.url?.trim())) ?? []

  const [isOpen, setIsOpen] = useState(defaultExpanded)

  if (validDocuments.length === 0) {
    return null
  }

  return (
    <OpportunityExpandableSection
      id='opportunity-expandable-documents'
      title={DOCUMENTS}
      isOpen={isOpen}
      onToggle={() => setIsOpen((open) => !open)}
      sectionTestId='opportunity-documents-section'
    >
      <ul className='opportunity-documents-list'>
        {validDocuments.map((document, idx) => (
          <li className='opportunity-documents-list-item' key={`${document.url}-${idx}`}>
            <FileIcon classes={['opportunity-documents-list-icon']} />
            <Anchor
              variant='basic-anchor'
              text={truncateString(document.title?.trim() || `Document ${idx + 1}`, 80)}
              target='_blank'
              href={document.url}
              classes={['opportunity-detail-document-anchor']}
            />
          </li>
        ))}
      </ul>
    </OpportunityExpandableSection>
  )
}

export default OpportunityDetailDocuments
